export enum TaxTerm {
    C2C = "b8113500-04ae-4321-ab19-4642c6411bd2",
    W2 = "cd368c36-14fa-461d-9b0c-b2be8a25a836",
}